import React from 'react';
import { Box, Divider } from '@drone-js/core';
import { useSelector } from 'react-redux';
import { mapStateToProps } from 'component/page/detail/DetailCard/KeyInfos/KeyInfo.selectors';
import { KeyItem } from 'component/page/detail/DetailCard/KeyInfos/KeyItem';
import { trackElementEvent } from 'core/messaging/analytics/analytics';
import { ActivitiesDetailsKeyInfoListSeenEventActivitiesFieldsV1 } from '@agoda/analytics-messages-definition-activities/events.split';
import { ActivitiesDetailsKeyInfoListSeenEventActivitiesManifestV1 } from '@agoda/analytics-messages-definition-activities/manifest/events';
import { selectScreenSize } from 'store/slice/screen';
import { InView } from 'react-intersection-observer';

export const KeyInfo: React.FC = () => {
    const keyInfoItems = useSelector(mapStateToProps);
    const screenSize = useSelector(selectScreenSize);

    if (keyInfoItems.length === 0) return null;

    const onSeen = (inView: boolean) => {
        if (inView && keyInfoItems.length > 0) {
            trackElementEvent<ActivitiesDetailsKeyInfoListSeenEventActivitiesFieldsV1>(ActivitiesDetailsKeyInfoListSeenEventActivitiesManifestV1.ids, {
                action_element_value: keyInfoItems.map((item) => item.type).join(','),
            });
        }
    };

    return (
        <InView onChange={onSeen} triggerOnce={true} threshold={1}>
            <Box
                data-element-name="activities-details-key-info-list"
                data-testid="activities-details-key-info-list"
                mt="12"
                display="flex"
                flexDirection={screenSize.tabletOrDesktop ? 'row' : 'column'}
                flexWrap="wrap"
            >
                <Divider color="base.subtle" mb="16" />
                {keyInfoItems.map((item) => (
                    <KeyItem key={item.type} type={item.type} text={item.text} iconId={item.icon} />
                ))}
            </Box>
        </InView>
    );
};
KeyInfo.displayName = 'KeyInfo';
